import React, { useEffect, useState, useMemo } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { get, post } from "../../services/api";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import Select from "react-select";
import { customTableStyles } from "../../assets/CustomTableStyles";

function EvaluationCriteriaWeightage() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");

  const [triggerRerender] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");

  const {
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    register,
    setValue,
    reset,
    getValues,
    trigger,
  } = useForm({
    defaultValues: {
      // id: 0,
      // name: "",
      // subjectId: 0,
      // createdBy: localStorage.getItem("userId"),
      // organizationId: organizationId,
    },
  });
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : localStorage.getItem("centerId");
  const [selectedClassId, setSelectedClassId] = useState(0);
  const [classesData, setClassesData] = useState([]);
  const [subjectData, setsubjectData] = useState([]);
  const [classCriteriaWeitage, setClassCriteriaWeitage] = useState([]);
  const [termData, setTermData] = useState([]);
  const [termDataId, settermDataId] = useState(0);
  const [selectedSubjectId, setSelectedSubjectId] = useState(0);

  useEffect(() => {
    fetchClassesByCenterId();
    fetchEvaluationCriteriaType();
    fetchEvaluationCriteriaWeitageByClassIdAndSubjectId();
  }, [triggerRerender, selectedSubjectId, termDataId]);
  const fetchEvaluationCriteriaWeitageByClassIdAndSubjectId = async () => {
    try {
      const response = await get(
        `StudentEvaluation/GetEvaluationCriteriaWeitageByClassIdAndSubjectId?classId=${selectedClassId}&subjectId=${selectedSubjectId}&criteriaId=${termDataId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setClassCriteriaWeitage(response.evaluationCriteriaWeitage);
    } catch (error) {
      console.error("Error fetching subject:", error);
    }
  };
  const fetchEvaluationCriteriaType = async () => {
    try {
      const response = await get(
        `StudentEvaluation/GetAllEvaluationCriteriaType?organizationId=${organizationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setTermData(response?.evaluationTypes);
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };
  const HandleEdit = async (id) => {
    try {
      if (id) {
        const response = await get(
          `StudentEvaluation/GetEvaluationCriteriaWeitageById?id=${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const evaluationCriteria = response.evaluationCriteriaWeitage;
        reset({
          id: evaluationCriteria.id,
          centerClassId: evaluationCriteria.centerClassId,
          className: evaluationCriteria.className,
          createdBy: evaluationCriteria.createdBy,
          // criteria: evaluationCriteria.criteria,
          subjectName: evaluationCriteria.subjectName,
          weightage: evaluationCriteria.weightage,
          subjectId: {
            value: evaluationCriteria?.subjectId || "",
            label: evaluationCriteria.subjectName || "",
          },
          centerClassId: {
            value: evaluationCriteria?.centerClassId || "",
            label: evaluationCriteria.className || "",
          },
          evaluationCriteriaTypeId: {
            value: evaluationCriteria.evaluationCriteriaTypeId,
            label: evaluationCriteria.evaluationCriteriaType,
          },
        });
      }
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };
  const HandleDelete = async (id) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this record?"
    );

    if (!confirmed) return;
    try {
      if (id) {
        const response = await get(
          `StudentEvaluation/DeleteEvaluationCriteriaWeitageById?id=${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.isSuccess) {
          toast.success(response.message || "Success!");
          fetchEvaluationCriteriaWeitageByClassIdAndSubjectId();
        } else {
          console.error("Error deleting holiday:", response.message);
        }
      }
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };
  const fetchClassesByCenterId = async () => {
    try {
      if (savedCenterId) {
        const response = await get(
          `CenterClass/GetClassCenterByCenterId?id=${savedCenterId}`,
          // `Class/GetClassByCenterIdAsync?centerId=${centerId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setClassesData(response);
      } else {
        setClassesData([]);
      }
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };
  const fetchSubjectByOrganizationId = async (ClassId) => {
    try {
      if (savedCenterId) {
        const response = await get(
          `Subject/GetAllSubject?centerId=${savedCenterId}&classId=${ClassId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setsubjectData(response.subjects);
      } else {
        setsubjectData([]);
      }
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  const filteredClassCriteriaWeitage = classCriteriaWeitage.filter((item) =>
    [
      item.className,
      item.subjectName,
      // item.criteria,
      item.weightage,
      item.evaluationCriteriaType,
    ].some((field) => field.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const columns = [
    {
      name: "Sr No.",
      cell: (row, index) => (currentPage - 1) * rowsPerPage + index + 1,
      sortable: false,
      width: "60px",
    },
    // {
    //   name: "Class",
    //   selector: (row) => row.className,
    //   sortable: true,
    // },
    {
      name: "Subject",
      selector: (row) => row.subjectName,
      sortable: true,
    },
    // {
    //   name: "Criteria",
    //   selector: (row) => row.criteria,
    //   sortable: true,
    // },
    {
      name: "Weightage",
      selector: (row) => row.weightage,
      sortable: true,
    },
    // {
    //   name: "Term",
    //   selector: (row) => row.evaluationCriteriaType,
    //   sortable: true,
    // },
    {
      name: "Action",
      selector: (row) => (
        <div className="d-flex gap-1">
          <button
            type="button"
            className="btn p-0"
            onClick={() => HandleEdit(row.id)}
          >
            <i className="fas fa-pen"></i>
          </button>
          <button
            type="button"
            className="btn p-0"
            onClick={() => HandleDelete(row.id)}
          >
            <i className="fas fa-trash"></i>
          </button>
        </div>
      ),
    },
  ];

  const saveData = async (data) => {
    data = {
      ...data,
      centerClassId: data.centerClassId.value,
      subjectId: data.subjectId.value,
      evaluationCriteriaTypeId: data.evaluationCriteriaTypeId.value,
      createdBy: localStorage.getItem("userId"),
    };
    if (!token) {
      console.error("Unauthorized.");
      return;
    }
    try {
      const response = await post(
        "StudentEvaluation/AddUpdateEvaluationCriteriaWeitage",
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        fetchEvaluationCriteriaWeitageByClassIdAndSubjectId();
        reset({
          // criteria: "",
          weightage: "",
        });
      }
    } catch (error) {
      console.error("Error.", error);
    }
  };
  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Evaluation Criteria Weightage</h2>
      </div>
      <form className="row g-3" onSubmit={handleSubmit(saveData)}>
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <div className="row g-3">
                <div className="col-md-4">
                  <label className="form-label">
                    Term
                    <span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="evaluationCriteriaTypeId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={termData.map((term) => ({
                          value: term.id,
                          label: term.type,
                        }))}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            settermDataId(null);
                          } else {
                            settermDataId(selectedOption.value);
                            setValue(
                              `evaluationCriteriaTypeId`,
                              selectedOption || 0
                            );
                            fetchEvaluationCriteriaWeitageByClassIdAndSubjectId();
                          }
                          // Trigger validation
                          trigger("evaluationCriteriaTypeId");
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable
                      />
                    )}
                  />
                  {errors.evaluationCriteriaTypeId && (
                    <small className="text-danger">
                      {errors.evaluationCriteriaTypeId.message}
                    </small>
                  )}
                </div>
                <div className="col-md-4">
                  <label className="form-label">
                    Year Group<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="centerClassId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={classesData.map((classItem) => ({
                          value: classItem.id,
                          label: classItem.name,
                        }))}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue("centerClassId", null);
                            setSelectedClassId(null);
                          } else {
                            setValue("centerClassId", selectedOption);
                            setSelectedClassId(selectedOption.value);
                            fetchSubjectByOrganizationId(selectedOption.value);
                          }
                          trigger("centerClassId");
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable
                      />
                    )}
                  />
                  {errors.centerClassId && (
                    <small className="text-danger">
                      {errors.centerClassId.message}
                    </small>
                  )}
                </div>
                <div className="col-md-4">
                  <label className="form-label">
                    Subject<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="subjectId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={subjectData
                          .filter((subject) => subject.status)
                          .map((subject) => ({
                            value: subject.id,
                            label: subject.name,
                          }))}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue("subjectId", null);
                          } else {
                            setValue("subjectId", selectedOption);
                            setSelectedSubjectId(selectedOption.value);
                            fetchEvaluationCriteriaWeitageByClassIdAndSubjectId();
                          }
                          trigger("subjectId");
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable
                      />
                    )}
                  />
                  {errors.subjectId && (
                    <small className="text-danger">
                      {errors.subjectId.message}
                    </small>
                  )}
                </div>

                {/* <div className="col-md-4">
                  <label className="form-label">
                    Criteria Name<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register(`criteria`, {
                      required: "This field is required.",
                    })}
                    type="text"
                    className="form-control"
                    placeholder=""
                  />
                  {errors.criteria && (
                    <small className="text-danger">
                      {errors.criteria.message}
                    </small>
                  )}
                </div> */}
                <div className="col-md-4">
                  <label className="form-label">
                    Weightage<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register(`weightage`, {
                      required: "This field is required.",
                    })}
                    type="text"
                    className="form-control"
                    placeholder=""
                  />
                  {errors.weightage && (
                    <small className="text-danger">
                      {errors.weightage.message}
                    </small>
                  )}
                </div>
                <div className="col-12 mt-3">
                  <button
                    className="btn btn-primary btn-sm"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Save" : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <div
                className="d-flex justify-content-end"
                style={{ marginTop: 0 }}
              >
                <div className="d-flex align-items-start gap-1">
                  <input
                    type="text"
                    className="form-control ms-2"
                    placeholder="Search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ width: "200px" }}
                  />
                </div>
              </div>
              <DataTable
                columns={columns}
                data={filteredClassCriteriaWeitage}
                pagination
                dense
                customStyles={customTableStyles}
                highlightOnHover={true}
                onChangePage={setCurrentPage}
                onChangeRowsPerPage={setRowsPerPage}
              />
            </div>
          </div>
        </div>
      </form>
    </>
  );
}

export default EvaluationCriteriaWeightage;
